import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    meetingRoomFailedPayment: [],
    lastError: null
};

export const meetingRoomFailedPaymentSlice = createSlice({
    name: "meetingRoomFailedPayment",
    initialState: initialState,
    reducers: {

        catchError: (state, action) => {
            state.error = { ...action.payload.error };
            state.loading = false;
        },

        startCall: (state, action) => {
            state.error = null;
            state.loading = true;
        },

        meetingRoomFailedPaymentFetched: (state, action) => {
            state.listLoading = false;
            state.error = null;
            state.meetingRoomFailedPayment = action.payload.meetingRoomFailedPayment;
        },
    }
});
